module.exports = "/React/dist/3e7bee344fbbe92da5e93af7c5b5925d.png";